
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Experience the thrill of water sports in Goa. From exciting jet skiing to relaxing scuba diving, enjoy a fun-filled day on the water with friends and family.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Dive into adventure with the best water sports package in Goa. Enjoy jet skiing, parasailing, and more at beautiful beaches.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Get ready for adventure with the Goa Water Sports Package. Enjoy thrilling activities like jet skiing and scuba diving at stunning beaches.',
},



        {
          hid: 'keywords',
          name: 'keywords',
          content: 'water sports goa, water sports goa package, water sports goa price, atlantis water sports goa, best beach for water sports in goa, best water sports in goa, water sports in goa in september, scuba diving and water sports in goa, water sports in goa timings, adventure water sports in goa',
        },
      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
  {
    title: "Thrilling Activities",
    text: "Experience heart-pounding adventures with exciting water sports like jet skiing, parasailing, and scuba diving!",
  },
  {
    title: "Fun for All Ages",
    text: "Whether you're a seasoned adventurer or a first-timer, there's a water sport for everyone to enjoy!",
  },
  {
    title: "Safety First",
    text: "All activities are conducted with safety in mind, with trained instructors ensuring a secure experience.",
  },
  {
    title: "Convenient Booking",
    text: "Easily book your water sports package through the Goa App for hassle-free planning and great deals!",
  },
],


     
      title: 'Water Sports Goa - Water Sports Goa Package and Price',
    };
  },

  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/watersports/water-sports-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/watersports/water-sports-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/watersports/water-sports-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Water Sports Goa",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Water Sports in Goa - Book @ ₹1499 Flat 40% Off",
  "description": "Enjoy the ultimate Water Sports in Goa with jet skiing, parasailing, banana boat, bumper, and speed boat rides for an action-packed experience!",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "1499",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/watersports/water-sports-goa",
        "url": "https://www.goa.app/watersports/water-sports-goa",
        "name": "Water Sports Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-11-01T09%3A23%3A21.579Zimg2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=JYmR%2FhscbqILeL5ZVh4sdCVH8LqwO3Vov7BmWSXyRejKdz1%2BivqKfmZbntG62iq2ijlLYx9tqpw2NH9DJHUUNBHpjcdEJU0MLDqHVSiDT7VWyTQgF51bcSmShE7eRuA6oP78y60MJwwYsLyPbYYDA%2F4ugm3KRJfzJ0gxJkw36yIZ32VOFYb0EBZhUZtjz8p%2BVWOo4%2BeFLVhJSAD23UOEGSRHaBs9E%2BIkXD2KwSjSL9Ulrt3ZkRHqiZyHsD6kvPHlUmwaROnfhPQyhinZUfh3%2BKEfzDQbXWe4ttWwrwwhIqq78vMZH7RFTwMSbxql5zTXLy1PYpyzWcYkJ2f6%2Fj9dVw%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "The Water Sports in Goa offers an exciting mix of jet skiing, parasailing, banana boat rides, bumper rides, and speed boat experiences. Perfect for adventure lovers, this package promises thrills and unforgettable memories on Goa’s beautiful waters.",
        "breadcrumb": {
            "@id": "https://www.goa.app/watersports/water-sports-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/watersports/water-sports-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
      "@type": "Question",
      "name": "What water sports are available in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In Goa, you can enjoy a variety of water sports including jet skiing, parasailing, scuba diving, banana boat rides, and kayaking."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of water sports in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prices for water sports in Goa typically start from ₹899 for basic activities and can go up to ₹3,499 for premium packages that include scuba diving."
      }
    },
    {
      "@type": "Question",
      "name": "Is scuba diving available in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many water sports packages in Goa offer scuba diving, with options suitable for both beginners and experienced divers."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need prior experience for water sports in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most water sports in Goa are beginner-friendly, and professional instructors are available to guide you, especially for activities like scuba diving and jet skiing."
      }
    },
    {
      "@type": "Question",
      "name": "What is the best time for water sports in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The best time for water sports in Goa is from November to April when the weather is pleasant and the sea conditions are ideal."
      }
    },
    {
      "@type": "Question",
      "name": "Are safety measures provided during water sports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all water sports operators in Goa prioritize safety and provide essential safety gear, including life jackets and helmets, for participants."
      }
    },
    {
      "@type": "Question",
      "name": "Can I book water sports activities online?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely! You can conveniently book water sports activities online through various platforms, including the Goa App, which often has special deals and offers."
      }
    },
    {
      "@type": "Question",
      "name": "What should I wear for water sports in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "It's advisable to wear a swimsuit, comfortable clothing, and flip-flops for water sports. Don't forget to apply sunscreen to protect your skin from the sun."
      }
    },
    {
      "@type": "Question",
      "name": "Are meals included in water sports packages?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Some water sports packages in Goa may include meals, while others might only offer refreshments. Be sure to check the package details before booking."
      }
    },
    {
      "@type": "Question",
      "name": "How do I find the best water sports package in Goa?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "To find the best water sports package in Goa, compare options online, read reviews, and look for promotions on platforms like the Goa App for discounts."
      }
    }  
        ]
      }
    ]
  };
},


};



  